// extracted by mini-css-extract-plugin
export default {"wrapper":"login_wrapper__D1jCg","redirectLogin":"login_redirectLogin__thzyS"};